<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p>To my wife, Linda, and my children, Tina, Melissa, Kim, Brigitte, Rebecca and Chuck. Also, to my grandchildren, Jeremy and Brandon.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?8e1b4a7a